// AI-CONTEXT: See docs/features/company-context-and-impact-per-euro.md

/**
 * Impact per euro = total Maatschappelijke waarde / total costs.
 *
 * @param {number|string} societalValue - total societal value (MW) in euros
 * @param {number|string} totalCosts - total costs for the year in euros
 * @returns {number|null} the ratio, or null when costs are absent/0/negative or
 *   either input is not a finite number (card renders "—" in that case)
 */
const calculateImpactPerEuro = (societalValue, totalCosts) => {
  const mw = Number(societalValue)
  const costs = Number(totalCosts)

  if (!Number.isFinite(mw) || !Number.isFinite(costs) || costs <= 0) {
    return null
  }

  return mw / costs
}

/**
 * @typedef {object} CompagnyCostsRow
 * @property {number} Year - the calendar year these costs cover
 * @property {number} TotalCosts - total costs in euros
 */

/**
 * Picks the costs row with the highest year — the denominator the live
 * Impact-per-euro KPI divides by.
 *
 * @param {CompagnyCostsRow[]} compagnyCosts
 * @returns {CompagnyCostsRow|null} the latest row, or null when none has a valid year
 */
const getLatestCosts = (compagnyCosts) => {
  if (!Array.isArray(compagnyCosts)) return null

  return compagnyCosts.reduce((latest, row) => {
    const year = Number(row?.Year)
    if (!Number.isFinite(year)) return latest
    if (!latest || year > Number(latest.Year)) return row
    return latest
  }, null)
}

export { calculateImpactPerEuro, getLatestCosts }
